import { render } from "./totop.vue?vue&type=template&id=96e1ef94&scoped=true"
import script from "./totop.vue?vue&type=script&lang=js"
export * from "./totop.vue?vue&type=script&lang=js"

import "./totop.vue?vue&type=style&index=0&id=96e1ef94&lang=less&scoped=true"

import exportComponent from "E:\\ekt.pro.git\\new-ekt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e1ef94"]])

export default __exports__